<template lang="pug">
  include /mixins
  div
    slot(:send='() => send(form)')
      +b.tt-landing-form-wrapper
        +e.title.H2 {{ _('Регистрация') }}
        +b.VALIDATION-OBSERVER(
          ref="validator",
          v-slot="{ valid }",
          tag="form",
        )
          +b.g-row
            template(v-if='config.length')
              //- +b.g-cell.g-cols--12.tt-space_mt--6(
              //-   v-for='{ rules, name, label, type, classname, mask, tag } in form_fields'
              //- )
              +b.g-cell.g-cols--12.tt-space_mt--6(
                v-for='{ rules, name, label, tag, type } in form_fields'
              )
                tag(
                  :tag='tag || "d-control-input"'
                  :rules="rules",
                  :input-label='label'
                  v-model='form[name]',
                  :ref='name'
                  @input='$emit("update", form)'
                  :name='name'
                  :type='type || "text"'
                )
              +b.g-cell.g-cols--12.tt-space_mt--6(
                v-for='field in config'
              )
                tag(
                  :tag='$options.TAG_MAP[field.props.type_input]',
                  v-bind="field", :ref='field.props.field.props.label', :name='field.props.field.props.label',
                  :rules="{ 'required': field.props.is_required, ...getValidation(field.props.field.props.validation) }",
                  :input-label='field.props.field.props.title', v-model='form[field.props.field.props.label]',
                )
              +b.g-cell.g-cols--12.tt-space_mt--6()
                validation-provider(
                  :rules='{ required: { allowFalse: false } }',
                  v-slot="{ errors }"
                  name='accept_rules'
                )
                  +b.d-control-input.--appearance_flexible
                    +e.element.INPUT(
                      type='checkbox'
                      name='accept_rules'
                      v-model='accept_rules'
                      id='accept_rules'
                    )

                    +e.LABEL.label--static(
                      for='accept_rules'
                    )
                      +b.ds-caption.--size_md.--color_black.P {{ _('Заполняя форму, Вы даете согласие на обработку персональных данных согласно ст. 6 и 7 GDPR. Подробности – в разделе') }} &nbsp;
                        +b.tt-link--inline.--styling_default.--black.A(:href='offer', target='_blank')
                          +b.ds-caption--size_md.SPAN {{ _('Политика конфиденциальности') }}
                    +b.error-label--top.LABEL(v-if="errors.length") {{ errors[0] }}
            +b.g-cell.g-cols--12.tt-space_mt--6
              +b.tt-button.BUTTON(
                @click.prevent='prepareData(valid)'
                type='submit'
              )
                +e.title.P {{ _(' Отправить') }}
</template>
<script>
import { mapState } from 'vuex'

import FormMixin, { defaultValidatorErrorsParser } from '@app/Forms/FormMixin'

import {
  AnswerMessage,
} from '@utils/submit'

import {
  getLandingFieldsResource,
  landingRequestCreateResource,
} from '@api/vendor.service'

import {
  isEmpty,
} from '@aspectus/vue-utils'
import {
  COUNTRY_CODE_COOKIE_NAME,
} from '@app/consts'
import {
  getCookie,
} from '@utils/cookies'

import pathOr from 'ramda/src/pathOr'

import TotikSuccess from '@app/TicketManagement/Success'
import ModalWrapper from '@app/Forms/ModalWrapper'

import {
  ADDRESS_BOOK_LIST_NAME,
} from '@app/Staff/AddressBook/routes'

const TAG_MAP = {
  input: 'd-control-input',
  select: 'd-control-input',
  phone: 'phone-input',
}

const ORDER_TYPE = 'order'
const PREORDER_TYPE = 'preorder'

const getType = () => (window.isPreorder ? PREORDER_TYPE : ORDER_TYPE)

export default {
  name: 'AddressBookAdd',
  props: {
    id: {
      type: [Number, String],
      default: null,
    },
    action: {
      type: String,
      default: null,
    },
    file: {
      type: String,
      default: null,
    },
    url: {
      type: String,
      default: null,
    },
    redirect_show_share: {
      type: Boolean,
      default: true,
    },
  },
  ADDRESS_BOOK_LIST_NAME,
  TAG_MAP,
  mixins: [FormMixin],
  getType,
  data() {
    return {
      config: [],
      accept_rules: false,
      isLoad: false,
      form_fields: [
        {
          name: 'phone',
          label: this._('Номер телефона'),
          rules: 'required|phone',
          tag: 'phone-input',
        },
      ],
      offer: window.offer,
      rules: window.rules,
      form: {
        first_name: window.request_name,
        last_name: window.request_lastname,
        email: window.request_email,
        phone: window.request_phone,
        source: window.location.href,
        city: window.request_city,
        middle_name: window.request_middlename,
        landing: this.id,
      },
    }
  },
  created() {
    if (this.id) {
      this.getLandingFields()
    }
  },
  methods: {
    getValidation(arr) {
      return arr.reduce((acc, item) => {
        if (item.props.rule) {
          acc = { ...acc, ...item.props.rule }
        }
        return acc
      }, {})
    },
    async getLandingFields() {
      const { data } = (await getLandingFieldsResource.execute({ id: this.id }))
      console.log(data);
      this.config = data
    },
    async prepareData(valid) {
      await this.$refs.validator.validate()
      if (!valid) return
      const data = JSON.parse(JSON.stringify(this.form))
      this.submit(valid, data)
    },
    send(data) {
      const action = landingRequestCreateResource
      return action.execute({ id: this.id }, data)
        .then(res => {
          // AnswerMessage(res.data, this)
          this.open(
            this._('Спасибо!'),
            this._('Ваша заявка успешно отправлена.')
          )
          this.form = {
            first_name: window.request_name,
            last_name: window.request_lastname,
            email: window.request_email,
            phone: window.request_phone,
            source: window.location.href,
            city: window.request_city,
            middle_name: window.request_middlename,
            landing: this.id,
          }
          this.$refs.validator.$el.reset()
          this.$refs.validator.reset()
        })
    },
    open(title, text) {
      this.$modal.show(
        ModalWrapper,
        {
          info: {
            tag: TotikSuccess,
            title,
            text,
            action: this.action,
            file: this.file,
            url: this.url,
            redirect_show_share: this.redirect_show_share,
          },
        }, {
          height: 'auto',
          classes: ['cookie-modal'],
          minWidth: 300,
          adaptive: true,
          scrollable: true,
        },
        {
          'before-close': () => {
            window.location.reload()
          },
        }
      )
    },
    updateValidator(errors) {
      const parsed = defaultValidatorErrorsParser(errors)
      this.non_field_errors = parsed.non_field_errors
      this.$refs.validator.setErrors(parsed)
    },
    simulate(event) {
      this.form = { ...this.form, ...event }
      this.$emit('update', this.form)
    },
  },
}
</script>
